import {
  FDCConcurrenceLevelSideEffect,
  FieldDesignChangeStatus,
  fullName,
} from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import WorkflowRollbackModal from 'components/CIMSModal/WorkflowRollbackModal'
import CIMSComment from 'components/CIMSComment'
import { useFDCTrackerContext } from '../../../FDCTrackerContext'
import { useWorkflowRollbackComment } from 'components/CIMSComment/hooks/useWorkflowRollbackComment'
import { dateFormatter } from 'utils/dateFormatter'

const RevertModal: React.FC = () => {
  const {
    fieldDesignChanges,
    metadata,
    mutations: { revert },
  } = useFDCTrackerContext()
  const { fn, is, state, visible, toggle } = revert
  return (
    <WorkflowRollbackModal
      visible={visible}
      onClose={() => toggle(null)}
      loading={is}
      onOk={async ({ comment }) => {
        if (!state) return
        await fn({
          variables: { input: { comment, id: state.id } },
        })
        fieldDesignChanges.refetch()
        toggle(null)
      }}
      recordName={state?.formattedNumber}
      endStatus={FieldDesignChangeStatus.PendingLevelConcurrences.name}
      affectedItems={[
        {
          label: 'Level',
          value: fullName(state?.concurrenceLevel),
          hidden: !metadata?.fdcConcurrenceLevels?.some(
            ({ id, sideEffectId }) =>
              sideEffectId === FDCConcurrenceLevelSideEffect.EarlyClosure.id &&
              id === state?.concurrenceLevel?.id
          ),
        },
        {
          label: 'Level Concurrences',
          value: (state?.fdcToFDCConcurrenceGroups ?? [])
            .filter(({ concurrenceGroup: { deleted } }) => !deleted)
            .map(
              ({
                concurrenceGroup: { name },
                concurred,
                concurrenceBy: { displayName, mail },
                concurrenceDate,
              }) => ({
                label: name,
                deletable: true,
                value: [
                  {
                    label: 'Concurrence By',
                    value: displayName ?? mail,
                  },
                  {
                    label: 'Concurrence Date',
                    value: dateFormatter.simple(concurrenceDate),
                  },
                  {
                    label: 'Concurred',
                    value: concurred ? 'True' : 'False',
                  },
                ],
              })
            ),
        },
        {
          label: 'Approvals',
          value: (state?.fdcToFDCApprovalGroups ?? [])
            .filter(({ approvalGroup: { deleted } }) => !deleted)
            .map(
              ({
                approvalGroup: { name },
                approved,
                approvalDate,
                approvalBy: { displayName, mail },
              }) => ({
                label: name,
                deletable: true,
                value: [
                  {
                    label: 'Approved By',
                    value: displayName ?? mail,
                  },
                  {
                    label: 'Concurrence Date',
                    value: dateFormatter.simple(approvalDate),
                  },
                  {
                    label: 'Approved',
                    value: approved ? 'True' : 'False',
                  },
                ],
              })
            ),
        },
      ]}
      formItems={
        <CIMSFormItem {...useWorkflowRollbackComment()}>
          <CIMSComment />
        </CIMSFormItem>
      }
    />
  )
}

export default RevertModal
